<div class="shop-details-container">
  <div class="header">
    <mat-icon class="back-arrow" (click)="goBack()">chevron_left</mat-icon>
    <span class="title">Shop Details</span>
    <span class="page-indicator"><span style="font-weight: 1000;font-size: larger;">3</span>/3</span>
  </div>

  <div class="form-section" *ngIf="formData">
    <form (ngSubmit)="onSubmitDetails()">
      <div class="form-field" [class.has-error]="validationErrors['mobileNumberPrimary']">
        <label for="primaryMobile" class="required">Primary mobile number</label>
        <input
          type="tel"
          id="primaryMobile"
          [(ngModel)]="formData.mobileNumberPrimary"
          name="primaryMobile"
          required
          [disabled]="true"
          (input)="onInputChange('mobileNumberPrimary')" />
        <div *ngIf="validationErrors['mobileNumberPrimary']" class="error-message">
          {{ validationErrors['mobileNumberPrimary'] }}
        </div>
      </div>

      <div class="form-field">
        <label for="alternateMobile">Alternate mobile number</label>
        <input
          type="tel"
          id="alternateMobile"
          [(ngModel)]="formData.mobileNumberAlternate"
          name="alternateMobile"
          maxlength="9"
          pattern="[0-9]{9}"
          (input)="onInputChange('mobileNumberAlternate')" />
        <div *ngIf="validationErrors['mobileNumberAlternate']" class="error-message">
            {{ validationErrors['mobileNumberAlternate'] }}
        </div>
      </div>

      <div class="form-field" [class.has-error]="validationErrors['retailerName']">
        <label for="ownerName">Owner name</label>
        <input
          type="text"
          id="ownerName"
          [(ngModel)]="formData.retailerName"
          name="ownerName"
          required
          (input)="onInputChange('retailerName')" />
        <div *ngIf="validationErrors['retailerName']" class="error-message">
          {{ validationErrors['retailerName'] }}
        </div>
      </div>

      <div class="form-field" [class.has-error]="validationErrors['type']">
        <label class="required">Shop type</label>
        <div class="radio-group">
          <label>
            <input type="radio" name="shopType" value="MAIN" [(ngModel)]="formData.type" required (change)="onInputChange('type')" /> Main
          </label>
          <label>
            <input type="radio" name="shopType" value="BRANCH" [(ngModel)]="formData.type" required (change)="onInputChange('type')" /> Branch
          </label>
        </div>
        <div *ngIf="validationErrors['type']" class="error-message">
            {{ validationErrors['type'] }}
        </div>
      </div>

      <div class="form-field" [class.has-error]="validationErrors['shopName']">
        <label for="shopName" class="required">Shop name</label>
        <input
          type="text"
          id="shopName"
          [(ngModel)]="formData.shopName"
          name="shopName"
          required
          (input)="onInputChange('shopName')" />
        <div *ngIf="validationErrors['shopName']" class="error-message">
          {{ validationErrors['shopName'] }}
        </div>
      </div>

      <div class="form-field" [class.has-error]="validationErrors['state']"  *ngIf="formData.state !== 'UNKNOWN'">
        <label for="county">County</label>
        <input
          type="text"
          id="county"
          [(ngModel)]="formData.state"
          name="county"
          [disabled]="true"
          (input)="onInputChange('state')" />
        <div *ngIf="validationErrors['state']" class="error-message">
          {{ validationErrors['state'] }}
        </div>
      </div>

      <div class="form-field" [class.has-error]="validationErrors['district']" *ngIf="formData.district !== 'UNKNOWN'">
        <label for="subCounty">Sub-County/Constituency</label>
        <input
          type="text"
          id="subCounty"
          [(ngModel)]="formData.district"
          name="subCounty"
          [disabled]="true"
          (input)="onInputChange('district')" />
        <div *ngIf="validationErrors['district']" class="error-message">
          {{ validationErrors['district'] }}
        </div>
      </div>

      <div class="form-field" [class.has-error]="validationErrors['village']"  *ngIf="formData.village !== 'UNKNOWN'">
        <label for="ward">Ward</label>
        <input
          type="text"
          id="ward"
          [(ngModel)]="formData.village"
          name="ward"
          [disabled]="true"
          (input)="onInputChange('village')" />
        <div *ngIf="validationErrors['village']" class="error-message">
          {{ validationErrors['village'] }}
        </div>
      </div>

      <div class="submit-button-wrapper">
        <button 
        mat-raised-button color="primary" 
        type="submit" 
        [disabled]="!isOnline"
        class="submit-button">{{isEditFlow ? 'Update Details' : 'Submit Details'}}</button>
      </div>
    </form>
  </div>

  <div *ngIf="!formData">
    <p>Dealer details not found.</p>
  </div>
</div>